import { render, staticRenderFns } from "./MaidQuote.vue?vue&type=template&id=5b011962&"
import script from "./MaidQuote.vue?vue&type=script&lang=js&"
export * from "./MaidQuote.vue?vue&type=script&lang=js&"
import style0 from "./MaidQuote.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MaidQuote.vue"
export default component.exports